<template lang='pug'>
.app.flex-row.align-items-center
  .container
    .row.justify-content-center
      .col-md-8
        .card-group.mb-4
          .card.p-4
            .card-body
              h1 Login
              p.text-muted Sign In to your account
              form(@submit.prevent="submit")
                .mb-3
                  .input-group
                    span.input-group-addon
                      i.icon-user
                    input.form-control(
                      name='email',
                      type='email',
                      placeholder='Email',
                      v-validate="'required|email'",
                      data-vv-validate-on='blur',
                      v-model='user.email'
                    )
                  div.text-danger(v-show="errors.has('email')") {{ errors.first('email') }}

                .mb-4
                  .input-group
                    span.input-group-addon
                      i.icon-lock
                    input.form-control(
                      name='password',
                      type='password',
                      placeholder='Password',
                      v-validate="'required'",
                      v-model='user.password'
                    )
                  div.text-danger(v-show="errors.has('password')") {{ errors.first('password') }}

                .row
                  .col-6
                    button.btn.btn-primary.px-4(type='submit') Login
                  .col-6.text-right
                    //- button.btn.btn-link.px-0(type='button') Forgot password?
          .card.text-white.bg-primary.py-5.d-md-down-none(style='width:44%')
            .card-body.text-center
              div
                .login-brand.mb-4
                p.text-left
                  | You must be logged in to access your data.
                  | The registration is not free, if you are an our customer and want to access the service,
                  |
                  span
                    strong
                      a.text-white(href='mailto:info@qicomposites.com') contact us
</template>

<script>
import Messages from '@/utils/notificationsMsg'
import Policeman from '@/utils/Policeman/policeman'

export default {
  name: 'Login',
  data () {
    return {
      user: {
        email: '',
        password: ''
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (Policeman.isLogged()) { return next({ name: 'Home' }) }
    return next()
  },
  methods: {
    submit () {
      this.$validator
          .validateAll()
          .then((result) => {
            if (result) {
              this.$store.dispatch('login', this.user)
                .then(res => {
                  this.showNotification(res.status)
                  this.$router.push({ name: 'Home' })
                })
                .catch(error => {
                  this.showNotification(error.response.status)
                })
            }
          })
          .catch(err => {
            console.log(err)
          })
    },
    showNotification (status) {
      return this.getMessage(Messages.byStatus(status, 'Login'))
    }
  },
  notifications: {
    getMessage: {}
  }
}
</script>

<style lang="sass">
  .login-brand
    height: 100px
    background:
      image: url('/static/img/logo-symbol.png')
      size: contain
      position: 50% 50%
      repeat: no-repeat
</style>



// WEBPACK FOOTER //
// src/components/Login.vue